export const GET_ALL_EVENTS_REQUEST = "GTE_ALL_EVENTS_REQUEST";
export const GET_ALL_EVENTS_SUCCESS = "GTE_ALL_EVENTS_SUCCESS";
export const GET_ALL_EVENTS_ERROR = "GTE_ALL_EVENTS_ERROR";

// ---- search events
export const SEARCH_EVENTS_REQUEST = "SEARCH_EVENTS_REQUEST";
export const SEARCH_EVENTS_REQUEST_FAIL = "SEARCH_EVENTS_REQUEST_FAIL";
export const SEARCH_EVENTS_SUCCESS = "SEARCH_EVENTS_SUCCESS";
export const SEARCH_EVENTS_ERROR = "SEARCH_EVENTS_ERROR";

// ---- seach event by cateory
export const CATEGORY_SEARCH_EVENTS_REQUEST = "CATEGORY_SEARCH_EVENTS_REQUEST";
export const CATEGORY_SEARCH_EVENTS_REQUEST_FAIL =
  "CATEGORY_SEARCH_EVENTS_REQUEST_FAIL";
export const CATEGORY_SEARCH_EVENTS_SUCCESS = "CATEGORY_SEARCH_EVENTS_SUCCESS";
export const CATEGORY_SEARCH_EVENTS_ERROR = "CATEGORY_SEARCH_EVENTS_ERROR";

// --- event details
export const GET_EVENTS_DEATILS_REQUEST = "GTE_EVENTS_DEATILS_REQUEST";
export const GET_EVENTS_DEATILS_SUCCESS = "GTE_EVENTS_DEATILS_SUCCESS";
export const GET_EVENTS_DEATILS_ERROR = "GTE_EVENTS_DEATILS_ERROR";

// --- TICKET GROUP DETIILS
export const GET_EVENTS_GROUP_DEATILS_REQUEST =
  "GTE_EVENTS_GROUP_DEATILS_REQUEST";
export const GET_EVENTS_GROUP_DEATILS_SUCCESS =
  "GTE_EVENTS_GROUP_DEATILS_SUCCESS";
export const GET_EVENTS_GROUP_DEATILS_ERROR = "GTE_EVENTS_GROUP_DEATILS_ERROR";

// ---- create order
export const CREATE_ORDER_REQUEST = "CREATE_ORDER_REQUEST";
export const CREATE_ORDER_SUCCESS = "CREATE_ORDER_SUCCESS";
export const CREATE_ORDER_ERROR = "CREATE_ORDER_ERROR";

// ------ filter the events
export const FILTERS_EVENTS_REQUEST = "FILTERS_EVENTS_REQUEST";
export const FILTERS_EVENTS_REQUEST_FAIL = "FILTERS_EVENTS_REQUEST_FAIL";
export const FILTERS_EVENTS_SUCCESS = "FILTERS_EVENTS_SUCCESS";
export const FILTERS_EVENTS_ERROR = "FILTERS_EVENTS_ERROR";

// ---- filter events at event page
// ------ filter the events
export const ALL_EVENTS_FILTERS_EVENTS_REQUEST =
  "ALL_EVENTS_FILTERS_EVENTS_REQUEST";
export const ALL_EVENTS_FILTERS_EVENTS_SUCCESS =
  "ALL_EVENTS_FILTERS_EVENTS_SUCCESS";

// ------ search the events
export const SEARCH_FILTER_EVENTS_REQUEST = "SEARCH_FILTER_EVENTS_REQUEST";
export const SEARCH_FILTER_EVENTS_REQUEST_FAIL =
  "SEARCH_FILTER_EVENTS_REQUEST_FAIL";
export const SEARCH_FILTER_EVENTS_SUCCESS = "SEARCH_FILTER_EVENTS_SUCCESS";
export const SEARCH_FILTER_EVENTS_ERROR = "SEARCH_FILTER_EVENTS_ERROR";


// get single event
export const GET_SINGLE_EVENT_REQUEST = "GET_SINGLE_EVENT_REQUEST";
export const GET_SINGLE_EVENT_SUCCESS = "GET_SINGLE_EVENT_SUCCESS";
 export const GET_SINGLE_EVENT_FAIL = "GET_SINGLE_EVENT_FAIL";
export const GET_SINGLE_EVENT_ERROR = "GET_SINGLE_EVENT_ERROR";

// get tax
export const GET_TAX_REQUEST = "GET_TAX_REQUEST";
export const GET_TAX_SUCCESS = "GET_TAX_SUCCESS";
export const GET_TAX_FAIL = "GET_TAX_FAIL";

// ---- user-created events
export const GET_USER_CREATED_EVENTS_REQUEST = "GET_USER_CREATED_EVENTS_REQUEST";
export const GET_USER_CREATED_EVENTS_SUCCESS = "GET_USER_CREATED_EVENTS_SUCCESS";
export const GET_USER_CREATED_EVENTS_ERROR = "GET_USER_CREATED_EVENTS_ERROR";